/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_PrefrencePostDto } from '../models/Wealthlane_AwardService_Dtos_PrefrencePostDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TablePreferencesService {

    /**
     * @param tableName
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTablePreferencesTablePreferences(
        tableName?: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/table-preferences/table-preferences',
            query: {
                'tableName': tableName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTablePreferencesTablePreferences(
        requestBody?: Wealthlane_AwardService_Dtos_PrefrencePostDto,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/table-preferences/table-preferences',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
